/** Lets non-React code (notifications, shortcuts) navigate and know what is on screen. */
let navigateFn: ((to: string) => void) | null = null;
let currentChannelId: string | null = null;
let channelListener: (() => void) | null = null;

export function setNavigator(fn: (to: string) => void): void {
  navigateFn = fn;
}

export function navigate(to: string): void {
  navigateFn?.(to);
}

export function setCurrentChannel(id: string | null): void {
  currentChannelId = id;
  channelListener?.();
}

export function getCurrentChannel(): string | null {
  return currentChannelId;
}

/** Called whenever the open channel changes (see viewing.ts). */
export function onCurrentChannelChange(fn: () => void): void {
  channelListener = fn;
}

export function channelPath(channel: { id: string; spaceId: string | null; type: string; parentId?: string | null }): string {
  if (channel.type === 'thread' && channel.parentId) return channel.spaceId ? `/app/${channel.spaceId}/${channel.parentId}` : `/app/@me/${channel.parentId}`;
  return channel.spaceId ? `/app/${channel.spaceId}/${channel.id}` : `/app/@me/${channel.id}`;
}
